import { render, staticRenderFns } from "./ReceptionHistoryCard.vue?vue&type=template&id=77b30ee8"
import script from "./ReceptionHistoryCard.vue?vue&type=script&lang=js"
export * from "./ReceptionHistoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports